import * as React from 'react'

const styles = require('./styles')

export const ErrorBoundary = () => (
  <div className={styles.container}>
    <h1>Something went wrong!</h1>
    <h3>We're working on a fix</h3>
    <p>
      Search and compare savings and personal loans with{' '}
      <a href="https://fiona.com" target="_blank">
        Fiona
      </a>
      !
    </p>
  </div>
)
